<template>
    <div>
        <modal :name="modal_name" class="final-modal edit-template" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background:#fff !important;">
                <div class="v-modal-header align-items-center" style="background:#ffffff !important;">
                    <span class="v-modal-dialog-title v-modal-title text-dark" style="text-transform:none !important;">
                        Edit Ticket Details
                    </span>
                    <span @click="hideView()" class="pointer">
                        <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/close_template.svg" alt="" style="height:25px">
                    </span>
                </div>
                <div class="general-section pl-0 pr-0 pb-1" style="background-color:#ffffff;border-radius:0px">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 460px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div class="general-section">
                                <div class="d-flex vendor_type mt-5" v-if="behalf != 'myself'">
                                    <span class="mr-5">Ticket on behalf of</span>
                                    <el-radio-group v-model="behalf" class="radiogroupcol">
                                        <el-radio v-if="onBehalf.Myself" :disabled="autoFilled" @input="behalfChange('myself')" label="myself">
                                            Myself(My Company)
                                        </el-radio>
                                        <el-radio v-if="onBehalf.Customer" :disabled="autoFilled" @input="behalfChange('customer')" label="customer">
                                            Customer
                                        </el-radio>
                                        <el-radio v-if="onBehalf.Vendor" :disabled="autoFilled" @input="behalfChange('vendor')" label="vendor">
                                            Vendor
                                        </el-radio>
                                    </el-radio-group>
                                </div>
                                <div class="row mt-5 mx-0">
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="w-100" v-if="behalf == 'myself'">
                                            <label class="inputLabel fs-14 fw-600 text-black">Ticket Creator<span class="text-danger pl-1">*</span></label>
                                            <input class="inputFieldNew" v-model="authorized_person_name" type="text" placeholder="Enter Ticket Creator Name" readonly />
                                            <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 20px;top: 45px;"></i>
                                            <span class="inputBorder"></span>
                                        </div> 
                                        <div class="form-group contactGroup" style="margin-top: -10px;z-index:1 !important;" v-if="behalf == 'customer'">
                                            <label class="text-black" style="font-size: 14px;margin-bottom: 0px;">Customer Name<span class="text-danger pl-1">*</span></label>
                                            <multiselect
                                                v-validate="'required'"
                                                class="diginew-multiselect mt-2"
                                                name="customer"
                                                label="label"
                                                v-model="customer"
                                                :options="customer_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Customer Name"
                                                :loading="customer_loading" @search-change="getAllCustomers"
                                                @close="updateCustomer(customer)"
                                            >
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfCustomer" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('customer')">{{ errors.first("customer") }}</span>
                                        </div>
                                        <div class="form-group contactGroup" style="margin-top: -10px;z-index:1 !important;" v-if="behalf == 'vendor'">
                                            <label class="text-black" style="font-size: 14px;margin-bottom: 0px;">Vendor Name<span class="text-danger pl-1">*</span></label>
                                            <multiselect
                                                v-validate="'required'"
                                                class="diginew-multiselect mt-2"
                                                name="vendor"
                                                label="label"
                                                v-model="vendor"
                                                :options="vendor_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Vendor Name"
                                                :loading="vendor_loading" @search-change="getAllVendors"
                                                @close="updateVendor(vendor)"
                                            >
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfVendors" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('vendor')">{{ errors.first("vendor") }}</span>
                                        </div>
                                        <!-- <button class="pull-right btn btn-secondary btn-smm mt-5" @click="viewMoreClick()">
                                            <span v-if="viewMore">View Less</span>
                                            <span v-else>View More</span>
                                        </button> -->
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="behalf == 'customer'">
                                        <div>
                                            <span class="fs-13 fw-600 text-dark">
                                                Branch<span class="text-danger pl-1">*</span>
                                            </span>
                                            <multiselect
                                                class="diginew-multiselect mt-4"
                                                name="branch_name"
                                                label="name"
                                                v-model="branch_name"
                                                :options="branch_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Branch"
                                                :disabled="!branch_active"
                                                @close="getAddressFromBranch(branch_name)"
                                            >
                                            <template slot="tag" slot-scope="{ option }">
                                                <span class="custom__tag">
                                                    <span class="filterSelectedName">{{ option.name }}</span>
                                                </span>
                                            </template>
                                            <template slot="afterList">
                                                <div v-observe-visibility="reachedEndOfBranch" />
                                            </template>
                                            <template slot="noOptions">
                                                <div class="text-secondary text-center fw-600">Branch Name Not Found</div>
                                            </template>
                                            <template slot="noResult">
                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                            </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="(ticketType.name == 'Product' || ticketType.name == 'Equipment') && showDept">
                                        <div class="w-100 mt-3">
                                            <label class="inputLabel fs-14 fw-600 text-black">Department<span class="text-danger pl-1">*</span></label>
                                            <input class="inputFieldNew" v-model="department.name" type="text" placeholder="Select Department" readonly />
                                            <span class="inputBorder"></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12">
                                        <div class="w-100">
                                            <label class="inputLabel fs-14 fw-600 text-black">Ticket Type<span class="text-danger pl-1">*</span></label>
                                            <input class="inputFieldNew mt-2" v-model="ticketType.name" type="text" placeholder="Select Ticket Type" readonly />
                                            <span class="inputBorder"></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="ticketType.name == 'Product' || ticketType.name == 'Equipment'" :class="{jobHide:showDept == false}">
                                        <span class="whiteSpace fs-14 fw-600 ml-2">Job Type</span>
                                        <div class="">
                                            <multiselect
                                                class="diginew-multiselect mt-3"
                                                name="job_type"
                                                v-model="job_type"
                                                :options="jobTypes"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Search & Select Job Type"
                                                internal-search="true"
                                                :disabled="is_job_type"
                                            >
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-12" v-if="ticketType.name == 'Product' || ticketType.name == 'Equipment'">
                                        <div class="w-100">
                                            <label class="inputLabel fs-14 fw-600 text-black">Customer Address</label>
                                            <input class="inputFieldNew addressPlace" style="padding-right: 30px !important;margin-top:8px" v-model="customer_address" type="text" placeholder="Customer Address" readonly />
                                            <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 16px;top: 43px;"></i>
                                            <span class="inputBorder"></span>
                                        </div> 
                                    </div>
                                </div>
                                <div class="row mt-5 mx-0">
                                    <div class="col-lg-5 col-md-6 col-sm-12 mb-5">
                                        <div class="form-group contactGroup" style="margin-top: 0px;">
                                            <div class="vendor_type">
                                                <label class="text-black mr-2" style="font-size: 14px;margin-bottom: 0px;">Assigned to
                                                    <span class="text-danger">*</span>
                                                    <span style="position:absolute;top:14px;left:auto; margin-left: -2px;">
                                                        <el-tooltip class="item pull-right" effect="dark" content="Employees" placement="top">
                                                            <i class="ri-2x ri-information-line text-black fs-16"></i>
                                                        </el-tooltip>
                                                    </span>
                                                </label>
                                                <el-radio-group class="d-flex align-items-center mt-2 mob-issue-fix" v-model="assignedTo">
                                                    <el-radio @input="assignedToChange()" label="person">
                                                        Person
                                                    </el-radio>
                                                    <el-radio @input="assignedToChange()" label="unassigned">
                                                        Unassigned
                                                    </el-radio>
                                                    <el-tooltip class="item pull-right" effect="dark" content="Assigning Tickets To Teams Coming Soon" placement="top">
                                                        <el-radio disabled @input="assignedToChange()" label="team">
                                                            Team
                                                        </el-radio>
                                                    </el-tooltip>
                                                </el-radio-group>
                                            </div>
                                            <multiselect label="name" v-if="assignedTo == 'person'"
                                                v-validate="'required'"
                                                class="diginew-multiselect mt-3"
                                                name="assigned"
                                                v-model="assignedCustomer"
                                                :options="assign_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Name"
                                                open-direction="top"
                                                :loading="assign_loading" @search-change="getAllAssignTo"
                                            >
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfAssigned" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('assigned')">{{ errors.first("assigned") }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="viewMore" style="background-color:#ecf5ff;" class="p-2 mt-2">
                                    <div class="row mx-0">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <label class="inputLabel fs-14 fw-600 text-black">Authorized Person Name<span class="text-danger pl-1">*</span></label>
                                                <input class="inputFieldNew" v-model="authorized_person_name" type="text" placeholder="Enter Authorized Person Name" readonly />
                                                <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 20px;top: 45px;"></i>
                                                <span class="inputBorder"></span>
                                            </div> 
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <label class="inputLabel fs-14 fw-600 text-black">Department<span class="text-danger pl-1">*</span></label>
                                                <input class="inputFieldNew" v-model="authorized_department" type="text" placeholder="Enter Authorized Person Name" readonly />
                                                <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 20px;top: 45px;"></i>
                                                <span class="inputBorder"></span>
                                            </div> 
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <label class="inputLabel fs-14 fw-600 text-black">Branch Name<span class="text-danger pl-1">*</span></label>
                                                <input class="inputFieldNew" v-model="authorized_branch" type="text" placeholder="Enter Authorized Person Name" readonly />
                                                <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 20px;top: 45px;"></i>
                                                <span class="inputBorder"></span>
                                            </div> 
                                        </div>
                                    </div>
                                    <div class="row pl-3 mt-5">
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <label class="inputLabel fs-14 fw-600 text-black">Authorized Person Mail ID<span class="text-danger pl-1">*</span></label>
                                                <input class="inputFieldNew" v-model="authorized_email" type="text" placeholder="Enter Authorized Person Name" readonly />
                                                <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 20px;top: 45px;"></i>
                                                <span class="inputBorder"></span>
                                            </div> 
                                        </div>
                                        <div class="col-lg-4 col-md-4 col-sm-12">
                                            <div class="w-100">
                                                <label class="inputLabel fs-14 fw-600 text-black">Authorized Person Phone Number<span class="text-danger pl-1">*</span></label>
                                                <input class="inputFieldNew" v-model="authorized_phone" type="text" placeholder="Enter Authorized Person Name" readonly />
                                                <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 20px;top: 45px;"></i>
                                                <span class="inputBorder"></span>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-5 mx-0">
                                    <div class="col-lg-8 col-md-8 col-sm-12 mt-3">
                                        <div class="w-100">
                                            <label class="inputLabel fs-14 fw-600 text-black">Ticket Subject <span class="text-danger pl-1">*</span></label>
                                            <input v-validate="'required'" name="subject" class="inputFieldNew" type="text" :maxlength="subjectlength" v-model="subject" placeholder="Enter Ticket Subject" />
                                            <span class="inputBorder"></span>
                                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('subject')" style="display: inline !important">{{ errors.first("subject") }}</span>
                                            <span class="pull-right text-right font-600 fs-12 pt-1">{{ subjectlength - subject.length}}/{{subjectlength}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="ticket_decription pointer mt-7 mx-3">
                                    <div class="decription"> Ticket Description </div>
                                    <div>
                                        <!-- <img @click="deleteDescription()" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dlt_desc.svg" alt="" class="dlt_descs"/> -->
                                        <vue-editor
                                            ondrop="return false;"
                                            class="mt-2"
                                            name="description"
                                            v-model="description"
                                            placeholder="Enter Description"
                                        ></vue-editor>
                                    </div>
                                    <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('description')">{{ errors.first("description") }}</span>
                                </div>
                                <!-- <div class="row pl-3 mt-3">
                                    <div class="col-lg-4 col-md-4 col-sm-4" v-if="showDept">
                                        <div class="w-100 mt-3">
                                            <label class="inputLabel fs-14 fw-600 text-black">Department<span class="text-danger pl-1">*</span></label>
                                            <input class="inputFieldNew" v-model="department.name" type="text" placeholder="Select Department" readonly />
                                            <span class="inputBorder"></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-5 col-md-8 col-sm-5 mb-5">
                                        <div class="form-group contactGroup" style="margin-top: 0px;">
                                            <div class="d-flex vendor_type">
                                                <label class="text-black" style="font-size: 14px;margin-bottom: 0px;">Assigned to
                                                    <span style="position:absolute;top:2px;left:70px">
                                                        <el-tooltip class="item pull-right" effect="dark" content="CRM Contacts (Customer, Vendor, Employees)" placement="top">
                                                            <i class="icon icon-information text-secondary fs-13"></i>
                                                        </el-tooltip>
                                                    </span> 
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <el-radio-group v-model="assignedTo">
                                                    <el-radio @input="assignedToChange()" label="person">
                                                        Person
                                                    </el-radio>
                                                    <el-radio disabled @input="assignedToChange()" label="team">
                                                        Team
                                                    </el-radio>
                                                    <el-radio @input="assignedToChange()" label="unassigned">
                                                        Unassigned
                                                    </el-radio>
                                                </el-radio-group>
                                            </div>
                                            <multiselect label="name" v-if="assignedTo == 'person'"
                                                v-validate="'required'"
                                                class="diginew-multiselect mt-3"
                                                name="assigned"
                                                v-model="assignedCustomer"
                                                :options="assign_options"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Select Name"
                                                open-direction="top"
                                                :loading="assign_loading" @search-change="getAllAssignTo"
                                            >
                                                <template slot="afterList">
                                                    <div v-observe-visibility="reachedEndOfAssigned" />
                                                </template>
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                            <span class="invalid-feedback-form text-danger mt-0 text-left d-block" v-show="errors.has('assigned')">{{ errors.first("assigned") }}</span>
                                        </div>
                                    </div>
                                    <div class="col-lg-3 col-md-4 col-sm-3">
                                        <div class="w-100 mt-4">
                                            <label class="inputLabel fs-14 fw-600 text-black">Ticket Type<span class="text-danger pl-1">*</span></label>
                                            <input class="inputFieldNew mt-2" v-model="ticketType.name" type="text" placeholder="Select Ticket Type" readonly />
                                            <span class="inputBorder"></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4" v-if="ticketType.name == 'Product' || ticketType.name == 'Equipment'" :class="{jobHide:showDept == false}">
                                        <span class="whiteSpace fs-14 fw-600 ml-2">Job Type</span>
                                        <div class="">
                                            <multiselect
                                                class="diginew-multiselect mt-3"
                                                name="job_type"
                                                v-model="job_type"
                                                :options="jobTypes"
                                                :searchable="true"
                                                :close-on-select="true"
                                                :show-labels="false"
                                                placeholder="Search & Select Job Type"
                                                internal-search="true"
                                                :disabled="is_job_type"
                                            >
                                                <template slot="noResult">
                                                    <div class="text-secondary text-center fw-600">No Results Found</div>
                                                </template>
                                            </multiselect>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4" v-if="ticketType.name == 'Product' || ticketType.name == 'Equipment'">
                                        <div class="w-100">
                                            <label class="inputLabel fs-14 fw-600 text-black">Customer Address</label>
                                            <input class="inputFieldNew addressPlace" style="padding-right: 30px !important;margin-top:8px" v-model="customer_address" type="text" placeholder="Customer Address" readonly />
                                            <i class="icon icon-check-circle fs-24 text-success ml-2" style="position: absolute;right: 16px;top: 43px;"></i>
                                            <span class="inputBorder"></span>
                                        </div> 
                                    </div>
                                </div> -->
                                <!-- attachments -->
                                <div class="general-section pt-2 pb-6 pl-sm-8 pr-sm-8 mt-4 d-flex justify-content-center px-3">
                                    <div class="attachment-bg attachment-bg-new pb-8">
                                        <div class="d-flex justify-content-center mt-4">
                                            <div class="img-upload pl-sm-15 pr-sm-15 pt-3 pb-3 text-center bg-white">
                                                <span class="pr-4 hide-on-mob">Drag and Drop Files Here</span>
                                                <span class="pr-4 hide-on-mob" style="font-weight:400 !important;">or</span>
                                                <label class="choose-file mt-1">
                                                    <input type="file" id="multiple" multiple @change="uploadAttachment" accept=".pdf,.doc,.xls,image/*">
                                                    Browse Files
                                                </label>
                                            </div>
                                        </div>
                                        <div class="example-full">
                                            <div class="btn-group" style="display: none;">
                                                <file-upload
                                                    class="btn btn-primary dropdown-toggle"
                                                    :multiple="multiple"
                                                    :directory="directory"
                                                    :size="size || 0"
                                                    :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                                                    :headers="headers"
                                                    :data="data"
                                                    :drop="drop"
                                                    :drop-directory="dropDirectory"
                                                    :add-index="addIndex"
                                                    v-model="temp_attachments"
                                                    @input-file="inputFile"
                                                    ref="upload"
                                                    webkitdirectory mozdirectory>
                                                    <i class="icon icon-plus"></i>
                                                    Select
                                                </file-upload>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-wrap align-items-center mt-4">
                                            <div class="col-lg-6 col-md-6 col-sm-12" v-for="(attachment,index) in attachments" :key="index">
                                                <div class="d-flex align-items-center mt-6 file-bg">
                                                    <div class="d-flex align-items-center" style="width:90%">
                                                        <div>
                                                            <img v-if="attachment.name.endsWith('.pdf')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/pdf-attachment.svg">
                                                            <img v-else-if="attachment.name.endsWith('.png')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/png-attachment.svg">
                                                            <img v-else-if="attachment.name.endsWith('.jpg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/jpg.svg">
                                                            <img v-else-if="attachment.name.endsWith('.svg')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/svg-icon.svg">
                                                            <img v-else-if="attachment.name.endsWith('.xls') || attachment.name.endsWith('.xlsx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/xls.svg">
                                                            <img v-else-if="attachment.name.endsWith('.doc') || attachment.name.endsWith('.docx')" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/docx.svg">
                                                        </div>
                                                        <div class="col">
                                                            <div class="d-flex justify-content-between">
                                                                <el-tooltip :content="attachment.name" placement="top">
                                                                    <div class="font-weight-bold text-truncate d-block mx-width-220">
                                                                        {{attachment.name}}
                                                                    </div>
                                                                </el-tooltip>
                                                            </div>
                                                            <div v-if="attachment.uploading || attachment.url == undefined">
                                                                <progress-bar class="progressBar w-100" :class="{'error-upload':attachment.url == undefined}" :val="attachment.progress" size="small"></progress-bar>
                                                            </div>    
                                                            <div class="d-flex justify-content-between">
                                                                <div class="text-danger pl-0 fw-500" v-if="attachment.error != ''">{{attachment.error}}...</div>
                                                                <div class="text-secondary fw-500" v-if="attachment.progress<100 && attachment.error == ''">{{attachment.progress}}% Uploading</div>
                                                                <div class="fw-500" v-if="attachment.size">({{attachment.size | prettyBytes}})</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="pointer ml-3" style="width:10%" @click="deleteAttachment(attachment,index)">
                                                        <i class="icon icon-close fs-16 closeAttachment" v-if="attachment.uploading || attachment.url == undefined"></i>
                                                        <i class="icon icon-trash text-secondary fs-20" v-if="attachment.url && attachment.uploading == false"></i>
                                                    </div>
                                                </div>
                                            </div>    
                                        </div>
                                    </div>     
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                        <a class="btn btn-danger btn-smm text-white" style="text-transform: uppercase !important;font-size: 12px !important;" @click="hideView()">CANCEL</a>
                        <button type="button" class="btn btn-success btn-smm text-white ml-4" :disabled="is_api_in_progress" @click="validateNext()" style="box-shadow: none;">
                            SAVE
                        </button>
                    </div>
                </div>
            </div>
        </modal>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import scm from '../mixins/scm.js';
import crm from '../mixins/crm.js';
import attachment from "../mixins/attachments.js";
import ticket from '../mixins/ticket.js';
import { SweetModal } from 'sweet-modal-vue';
import FileUpload from 'vue-upload-component';
export default {
    props:['modal_name','ticket_id','source'],
    mixins:[scm,crm,ticket,attachment],
    components:{
        VueEditor,
        SweetModal,
        FileUpload
    },
    data(){
        return{
            success_msg:'',
            warning_msg:'',
            behalf:'myself',
            is_api_in_progress:false,
            assignedTo:'person',
            subject:'',
            department:'',
            department_options:[],
            assignedCustomer:'',
            assign_options:[],
            ticketType:'',
            ticket_type_options:[],
            subjectlength:100,
            ajaxCallinprogress:false,
            customer_options:[],
            customer:'',
            vendor_options:[],
            vendor:'',
            vendor_count:0,
            vendor_loading:false,
            vendor_scrollable:false,
            vendor_visible:false,
            search_key:'',
            temp_vendor_options:[],
            customer_loading:false,
            customer_count:0,
            temp_customer_options:[],
            customer_scrollable:false,
            cutomer_visible:false,
            viewMore:false,
            authorized_person_id:'',
            authorized_person_name:'',
            authorized_department:'',
            authorized_branch:'',
            authorized_email:'',
            authorized_phone:'',
            ticket_template_type:'',
            temp_assign_options:[],
            assign_loading:false,
            assign_scrollable:false,
            assign_count:0,
            description:'',
            showDescription:false,
            is_parent_ticket:false,
            parent_ticket_id:'',
            api_response:{},
            is_validated:false,
            temp_attachments:[],
            accept: '*',
            extensions: '*',
            size: 1024 * 1024 * 10,
            multiple: true,
            directory: true,
            drop: true,
            dropDirectory: true,
            addIndex: false,
            thread: 3,
            name: 'file',
            postAction: '/upload/post',
            putAction: '/upload/put',
            headers: {
                'X-Csrf-Token': 'xxxx',
            },
            data: {
                '_csrf_token': 'xxxxxx',
            },
            autoCompress: 1024 * 1024,
            uploadAuto: false,
            isOption: false,
            attachments:[],
            branch_options:[],
            branch_name:'',
            branch_count:0,
            branch_loading:false,
            branch_scrollable:false,
            branch_visible:false,
            temp_branch_options:[],
            branch_active: false,
            customer_address:'',
            job_type:'',
            jobTypes:[],
            is_job_type: false
        }
    },
    methods:{
        inputFile(newFile, oldFile) {
            this.temp_attachments = []
            if (newFile && oldFile) {
                if (newFile.active && !oldFile.active) {
                if (newFile.size >= 0 && this.minSize > 0 && newFile.size < this.minSize) {
                    this.$refs.upload.update(newFile, { error: 'size' })
                }
                }
                if (newFile.progress !== oldFile.progress) {
                }
                if (newFile.error && !oldFile.error) {
                }
                if (newFile.success && !oldFile.success) {
                }
            }
            if (!newFile && oldFile) {
                if (oldFile.success && oldFile.response.id) {
                }
            }
            if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                if (this.uploadAuto && !this.$refs.upload.active) {
                this.$refs.upload.active = true
                }
            }
            this.input_file = newFile.file
            this.uploadAttachment(event)
        },
        deleteAttachment(attachment,index){
            this.attachments.forEach((el,elindex)=>{
                if(el.url == attachment.url){
                    this.attachments.splice(elindex,1)
                }
            })
        },
        deleteDescription(){
            this.description = ''
        },
        hideView(){
            this.$modal.hide(this.modal_name);
            this.$emit('hideEditBase')
        },
        validateNext(){
            this.$validator.validateAll().then(result => {
                if (result == true){
                    if(this.ticketType.name == 'Spare Part Requirement'){
                        if(this.assignedTo == 'unassigned'){
                            this.warning_msg = 'Employee has to assigned for this ticket'
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }else{
                            this.apiCall()
                        }
                    }else if(this.ticketType.name == 'Spare Part Installation'){
                        if(this.assignedTo == 'unassigned'){
                            this.warning_msg = 'Employee has to assigned for this ticket'
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.$refs.warning_modal.close();
                            }, 3000);
                        }else{
                            this.apiCall()
                        }
                    }else {
                        this.apiCall()
                    }
                }else{
                    this.$toasted.global.error("Please Fill All The Required Fields")
                }
            })
        },
        apiCall(){
            this.attachments.forEach(attachment => {
                delete attachment['id'];
                delete attachment['progress']
                delete attachment['uploading'] 
                delete attachment['error']
                delete attachment['size']
                delete attachment['created_time']
            })
            if(this.source == 'draft'){
                this.is_validated = true
                this.confirmSaveDraft()
            }else{
                this.confirmSave()
            }
        },
        async confirmSave(){
            this.is_api_in_progress = true
            try {
                let res = await this.editTicket(this.create_json)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$emit('saveEditBase')
                    this.hideView()
                }, 2000);
            } catch (reason) {
                this.is_api_in_progress = false
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
                // this.$refs.warning_modal.open();
                // setTimeout(() => {
                //     this.$refs.warning_modal.close();
                // }, 3000);
            }
        },
        async confirmSaveDraft(){
            try {
                let res = await this.draftUpdate(this.save_draft_json)
                this.success_msg = res.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.$emit('saveEditBase')
                    this.hideView()
                }, 2000);
            } catch (reason) {
                this.warning_msg = reason
                this.$swal({
                    imageUrl:'https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg',
                    text: this.warning_msg,
                    showConfirmButton:false
                })
                // this.$refs.warning_modal.open();
                // setTimeout(() => {
                //     this.$refs.warning_modal.close();
                // }, 3000);
            }
        },
        descriptionShow(){
            if(this.showDescription){
                this.showDescription = false
            }else{
                this.showDescription = true
            }
        },
        async getAllAssignTo(search_key){
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getUserForTickets(params)
                this.assign_options = res.response.assigned_user_details
                this.assign_count = this.temp_assign_options.length
                this.assign_loading = false
                this.assign_scrollable = false
            } catch (reason) {
                
            }
        },
        async reachedEndOfAssigned(reached){
            this.cutomer_visible = reached
            if (reached) {
                if (this.assign_scrollable == false) {
                    this.assign_loading = true
                    let params ={
                        skip:this.assign_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getUserForTickets(params)
                    this.temp_assign_options = response.response.assigned_user_details.length;
                    if (response.response.skip == this.assign_count) {
                        if (this.temp_assign_options > 0) {
                            let tempFiles = response.response.assigned_user_details;
                            tempFiles.forEach(el => {
                                this.assign_options.push(el);
                            });
                            this.assign_count += response.response.assigned_user_details.length;
                            this.assign_loading = false
                        } else {
                            this.assign_scrollable = true
                            this.assign_loading = false
                        }
                    }
                    this.assign_loading = false
                }
            }
        },
        viewMoreClick(){
            if(this.viewMore){
                this.viewMore = false
            }else{
                this.viewMore = true
            }
        },
        updateVendor(vendor){
            if(vendor){
                if(vendor.employee_name){
                    this.authorized_person_name = vendor.employee_name.name 
                    this.authorized_person_id = vendor.employee_name.id
                }
                if(vendor.department && vendor.department.length) this.authorized_department = vendor.department
                if(vendor.branch) this.authorized_branch = vendor.branch
                this.authorized_email = vendor.email
                this.authorized_phone = vendor.phone_number
            }else{
                this.authorized_person_name = ''
                this.authorized_department = ''
                this.authorized_branch = ''
                this.authorized_email = ''
                this.authorized_phone = ''
                this.authorized_person_id = ''
            }
        },
        updateCustomer(customer){
            if(customer){
                if(customer.employee_name){
                    this.authorized_person_name = customer.employee_name.name 
                    this.authorized_person_id = customer.employee_name.id
                }
                if(customer.department && customer.department.length) this.authorized_department = customer.department
                if(customer.branch) this.authorized_branch = customer.branch
                this.authorized_email = customer.email
                this.authorized_phone = customer.phone_number
                this.branch_active = true
            }else{
                this.authorized_person_name = ''
                this.authorized_department = ''
                this.authorized_branch = ''
                this.authorized_email = ''
                this.authorized_phone = ''
                this.authorized_person_id = ''
                this.branch_active = false
            }
        },
        behalfChange(value){
            if(value == 'myself'){
                this.authorized_person_name = this.loggedInUser.full_name
                if(this.loggedInUser.department && this.loggedInUser.department.length) this.authorized_department = this.loggedInUser.department[0]
                this.authorized_branch = this.loggedInUser.branch || ''
                this.authorized_email = this.loggedInUser.email
                this.authorized_phone = this.loggedInUser.phone || ''
                this.authorized_person_id = this.loggedInUser.user_id || ''
                this.customer = ''
                this.vendor = ''
                this.$validator.reset();
            }else{
                this.customer = ''
                this.vendor = ''
                this.authorized_person_name = ''
                this.authorized_department = ''
                this.authorized_branch = ''
                this.authorized_email = ''
                this.authorized_phone = ''
                this.$validator.reset();
            }
            this.$validator.reset();
            this.errors.clear()
        },
        assignedToChange(){
            this.assignedCustomer = ''
            this.$validator.reset();
        },
        async getAllCustomers(search_key){
            try {
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getCustomerForTickets(params)
                this.customer_options = res.response.customer_list
                this.customer_count = this.temp_customer_options.length
                this.customer_loading = false
                this.customer_scrollable = false
                this.customer_options.forEach((el,index)=>{
                    el['label'] = el.employee_name.name
                })
            } catch (reason) {
                
            }
        },
        async reachedEndOfCustomer(reached){
            this.cutomer_visible = reached
            if (reached) {
                if (this.customer_scrollable == false) {
                    this.customer_loading = true
                    let params ={
                        skip:this.customer_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getCustomerForTickets(params)
                    this.temp_customer_options = response.response.customer_list.length;
                    if (response.response.skip == this.customer_count) {
                        if (this.temp_customer_options > 0) {
                            let tempFiles = response.response.customer_list;
                            tempFiles.forEach(el => {
                                this.customer_options.push(el);
                            });
                            this.customer_count += response.response.customer_list.length;
                            this.customer_loading = false
                        } else {
                            this.customer_scrollable = true
                            this.customer_loading = false
                        }
                        this.customer_options.forEach((el,index)=>{
                            el['label'] = el.employee_name.name
                        })
                    }
                    this.customer_loading = false
                }
            }
        },
        async getAllVendors(search_key){
            try {
                this.vendor_loading = true
                let params ={
                    skip:0,
                    limit:10,
                    search_key:search_key
                }
                let res = await this.getSCMVendors(params)
                this.vendor_options = res.response.vendors_list
                this.vendor_count = this.temp_vendor_options.length
                this.vendor_loading = false
                this.vendor_scrollable = false
                this.vendor_options.forEach((el,index)=>{
                    el['label'] = el.name.name
                })
            } catch (reason) {
                
            }
        },
        async reachedEndOfVendors(reached){
            this.vendor_visible = reached
            if (reached) {
                if (this.vendor_scrollable == false) {
                    this.vendor_loading = true
                    let params ={
                        skip:this.vendor_count,
                        limit:10,
                        search_key:this.search_key
                    }
                    let response = await this.getSCMVendors(params)
                    this.temp_vendor_options = response.response.vendors_list.length;
                    if (response.response.skip == this.vendor_count) {
                        if (this.temp_vendor_options > 0) {
                            let tempFiles = response.response.vendors_list;
                            tempFiles.forEach(el => {
                                this.vendor_options.push(el);
                            });
                            this.vendor_count += response.response.vendors_list.length;
                            this.vendor_loading = false
                        } else {
                            this.vendor_scrollable = true
                            this.vendor_loading = false
                        }
                        this.vendor_options.forEach((el,index)=>{
                            el['label'] = el.name.name
                        })
                    }
                    this.vendor_loading = false
                }
            }
        },
        async reachedEndOfBranch(reached) {
            this.branch_visible = reached
            if (reached) {
                if (this.branch_scrollable == false) {
                    this.branch_loading = true
                    let params = {
                        company_name: this.customer.employee_name.name
                    }
                    let response = await this.getBranches(params)
                    this.temp_branch_options = response.response.all_branches.length;
                    if (response.response.skip == this.branch_count) {
                        if (this.temp_branch_options > 0) {
                            let tempFiles = response.response.all_branches;
                            tempFiles.forEach(el => {
                                this.branch_options.push(el);
                            });
                            this.branch_count += response.response.all_branches.length;
                            this.branch_loading = false
                        } else {
                            this.branch_scrollable = true
                            this.branch_loading = false
                        }
                    }
                    this.branch_loading = false
                }
            }
        },
        getAddressFromBranch(branch_name) {
            if(branch_name) {
                this.customer_address = branch_name.address;
            }
            else {
                this.customer_address = '';
            }
        },
        async getAllJobTypes() {
            return new Promise(async (resolve, reject) => {
                let params =  {
                    settings_type:['job_type']
                }
                const response = await this.$http.post('/settings/get_all_settings_by_type',params)
                if (response.data.status_id === 1) {
                    resolve(response.data)
                } else {
                    reject(response.data.reason)
                }
            })
        },
        async getAllJobTypesAPI(){
            try {
                let res = await this.getAllJobTypes()
                if(res.response && res.response.job_type){
                    res.response.job_type.forEach((el,index)=>{
                        this.jobTypes.push(el.job_type)
                    })
                }
            } catch (reason) {
                
            }
        },
        async getDetails(){
            try {
                let params = {
                    ticket_id:this.ticket_id
                }
                let res = await this.getTicketData(params)
                this.api_response = res.response.ticket_data
                if(this.api_response && this.api_response.creation_details){
                    this.behalf = this.api_response.creation_details.for
                    this.attachments = this.api_response.attach_files
                    this.attachments.forEach((el,index)=>{
                        el['uploading'] = false
                    })
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.employee_name){
                        this.authorized_person_name = this.api_response.creation_details.id.employee_name.name
                        this.authorized_person_id = this.api_response.creation_details.id.employee_name.id
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.department && this.api_response.creation_details.id.department.length){
                        this.authorized_department = this.api_response.creation_details.id.department[0]
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.branch){
                        this.authorized_branch = this.api_response.creation_details.id.branch.name
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.email){
                        this.authorized_email = this.api_response.creation_details.id.email
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.phone_number){
                        this.authorized_phone = this.api_response.creation_details.id.phone_number
                    }
                    if(this.api_response.creation_details.branch.id && this.api_response.creation_details.branch){
                        this.branch_name = this.api_response.creation_details.branch
                    }
                    this.subject = this.api_response.subject
                    if(this.api_response.job_type) {
                        this.is_job_type = true
                    }
                    this.job_type = this.api_response.job_type
                    this.customer_address = this.api_response.customer_address
                    if(this.api_response.ticket_template){
                        this.ticketType = this.api_response.ticket_template
                    }
                    this.description = this.api_response.description
                    if(this.api_response.assignment_details && this.api_response.assignment_details.id){
                        this.assignedCustomer = this.api_response.assignment_details.id
                        this.assignedTo = this.api_response.assignment_details.to
                    }  
                    if(this.api_response.department){
                        this.department = this.api_response.department
                    }
                    if(this.behalf == 'vendor' && this.api_response.creation_details.id && this.api_response.creation_details.id.employee_name){
                        this.vendor = this.api_response.creation_details.id.employee_name
                        this.vendor['label'] = this.vendor.name
                    }else if(this.behalf == 'customer' && this.api_response.creation_details.id && this.api_response.creation_details.id.employee_name){
                        this.customer = this.api_response.creation_details.id.employee_name
                        this.customer['label'] = this.customer.name
                    }
                }
                
            } catch (reason) {
                
            }
        },
        async getDetailsDraft(){
            try {
                let params = {
                    draft_ticket_id:this.ticket_id
                }
                let res = await this.getDraftData(params)
                this.api_response = res.response.ticket_data
                if(this.api_response){
                    this.subject = this.api_response.subject
                    if(this.api_response.ticket_template){
                        this.ticketType = this.api_response.ticket_template
                    }
                    this.description = this.api_response.description
                    if(this.api_response.assignment_details && this.api_response.assignment_details.id){
                        this.assignedCustomer = this.api_response.assignment_details.id
                        this.assignedTo = this.api_response.assignment_details.to
                    }  
                    if(this.api_response.department){
                        this.department = this.api_response.department
                    }
                    this.is_validated = this.api_response.is_validated
                    this.is_parent_ticket = this.api_response.is_parent_ticket || false
                    this.attachments = this.api_response.attach_files
                    this.attachments.forEach((el,index)=>{
                        el['uploading'] = false
                    })
                }
                if(this.api_response && this.api_response.creation_details){
                    this.behalf = this.api_response.creation_details.for
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.employee_name){
                        this.authorized_person_name = this.api_response.creation_details.id.employee_name.name
                        this.authorized_person_id = this.api_response.creation_details.id.employee_name.id
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.department && this.api_response.creation_details.id.department.length){
                        this.authorized_department = this.api_response.creation_details.id.department[0]
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.branch){
                        this.authorized_branch = this.api_response.creation_details.id.branch.name
                    }
                    if(this.api_response.creation_details.branch.id && this.api_response.creation_details.branch){
                        this.branch_name = this.api_response.creation_details.branch
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.email){
                        this.authorized_email = this.api_response.creation_details.id.email
                    }
                    if(this.api_response.creation_details.id && this.api_response.creation_details.id.phone_number){
                        this.authorized_phone = this.api_response.creation_details.id.phone_number
                    }
                    if(this.behalf == 'vendor' && this.api_response.creation_details.id && this.api_response.creation_details.id.employee_name){
                        this.vendor = this.api_response.creation_details.id.employee_name
                        this.vendor['label'] = this.vendor.name
                    }else if(this.behalf == 'customer' && this.api_response.creation_details.id && this.api_response.creation_details.id.employee_name){
                        this.customer = this.api_response.creation_details.id.employee_name
                        this.customer['label'] = this.customer.name
                    }
                    if(this.api_response.job_type) {
                        this.is_job_type = true
                    }
                    this.job_type = this.api_response.job_type
                    this.customer_address = this.api_response.customer_address
                }
                
            } catch (reason) {
                
            }
        }
    },
    computed:{    
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        },
        getGeneralSettings(){
            return this.$store.state.store.getGeneralSettings
        },
        showDept(){
           return this.$store.state.store.getGeneralSettings.display_department_section_in_base_template.display_department_section_in_base_template
        },
        onBehalf(){
            if(this.getGeneralSettings && this.getGeneralSettings.create_ticket_on_behalf_of){
                return this.getGeneralSettings.create_ticket_on_behalf_of.create_ticket_on_behalf_of
            }else{
                return ''
            }
        },
        create_json(){
            return{
                assignment_details:{
                    id:this.assignedCustomer.id,
                    is_assigned:true,
                    to:this.assignedTo
                },
                creation_details:{
                    for:this.behalf,
                    id:this.authorized_person_id,
                    branch: this.branch_name,
                },
                description:this.description,
                text:this.description.replace(/(<([^>]+)>)/ig, ""),
                subject:this.subject,
                ticket_id:this.ticket_id,
                customer_address:this.customer_address,
                attach_files:this.attachments,
            }
        },
        save_draft_json(){
            return{
                assignment_details:{
                    id:this.assignedCustomer.id,
                    is_assigned:true,
                    to:this.assignedTo
                },
                creation_details:{
                    for:this.behalf,
                    id:this.authorized_person_id,
                    branch: this.branch_name,
                },
                description:this.description,
                text:this.description.replace(/(<([^>]+)>)/ig, ""),
                subject:this.subject,
                draft_ticket_id:this.ticket_id,
                is_validated:this.is_validated,
                attach_files:this.attachments,
                department:this.department.id || '',
                ticket_template:this.ticketType.id || '',
                is_parent_ticket:this.is_parent_ticket || false
            }
        }
    },
    async mounted(){
        if(this.source == 'draft'){
            this.getDetailsDraft()
        }else{
            this.getDetails()
        }
        this.getAllJobTypesAPI()
        
    },
    created(){
        const dict = {
            custom: {
                customer:{
                    required:() => "Customer is Required",
                },
                vendor:{
                    required:() => "Vendor is Required",
                },
                subject:{
                    required:() => "Ticket Subject is Required",
                },
                department:{
                    required:() => "Department is Required",
                },
                assigned:{
                    required:() => "Assigned to is Required",
                },
                ticketType:{
                    required:() => "Ticket Type is Required"
                },
                description:{
                    required:() => "Description is Required"
                }
            }
        }
        this.$validator.localize("en", dict); 
    }
}
</script>
<style scoped>

.activeDetails{
    background-color: #00448f !important;
    color: #fff !important;
    width: 200px !important;
    border-radius: 14px !important;
    height: 40px !important;
    font-weight: 500 !important;
    text-transform: none;
    font-size: 16px !important;
}
.boxHeader{
    background: #0475f3;
    color: #fff;
    padding: 5px 25px;
    font-weight: 500;
    font-size: 14px;
}
.boxShadow{
    box-shadow: 0px 0.5px 7px 2px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    border-radius: 8px;
}
.vendor_type span{
    margin-left: 10px;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #000000;
}
.btn-blue{
    background: #005dae;
    color: #fff;
}
.ticket_decription{
    border: 1px solid #707070;
    border-radius: 10px;
}
.decription{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: 8px 25px;
    font-size: 15px;
    font-weight: 500;
    border-bottom: 1px solid #303031;
}
.dlt_descs{
    float: right;
    position: relative;
    bottom: 40px;
    right: 10px;
}
.btn-upload {
    background: #1c61c2;
    border-radius: 7px !important;
}
.attachment-bg-new{
    border: 1px solid #005dae !important;
    background: transparent !important;
    width: 100%;
}
.file-bg{
    background-color: #bbd9fd;
    padding: 10px;
    border-radius: 2px;
}
.jobHide{
    margin-top: 14px !important;
}
</style>